import { CSSProperties, DetailedHTMLProps, FC, HTMLAttributes } from 'react'

import { AspectRatio, clsx, MediaQuery } from '@mantine/core'
import Link, { LinkProps } from 'next/link'

import { cssHomeBannerImage } from './HomeBannerImage.styled'
import { HomeBannerItem } from '../'
import { StyledHomeBannerImage } from '../HomeBanner.styled'

type HomeBannerPropsOmit = 'children' | 'onClick' | 'className' | 'style'
export type HomeBannerImageProps = {
  banner: Partial<HomeBannerItem>
  bannerProps?:
    | Omit<LinkProps, HomeBannerPropsOmit>
    | Omit<
        DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
        HomeBannerPropsOmit
      >
  isMobile?: boolean
  desktopRatio?: 'auto' | number
  mobileRatio?: 'auto' | number
  style?: CSSProperties
  className?: string
}
export const HomeBannerImage: FC<HomeBannerImageProps> = (props) => {
  const {
    isMobile,
    banner,
    bannerProps,
    style,
    className,
    desktopRatio = 'auto',
    mobileRatio = 'auto',
  } = props
  const { desktop, mobile, url, openNewTab } = banner || {}

  const Container = url ? Link : 'div'
  const containerProps: any = url
    ? {
        ...bannerProps,
        href: url,
        target: openNewTab ? '_blank' : '_self',
        className: clsx(className, cssHomeBannerImage),
        css: cssHomeBannerImage,
        style: style,
      }
    : {
        ...bannerProps,
        className: clsx(className),
        css: cssHomeBannerImage,
        style: style,
      }

  const mobileImageComp =
    mobileRatio === 'auto' ? (
      <img loading="lazy" src={mobile} alt="" />
    ) : (
      <AspectRatio ratio={mobileRatio}>
        <StyledHomeBannerImage url={mobile} />
      </AspectRatio>
    )

  if (!desktop && !mobile) {
    return null
  }

  // Show on Mobile device
  if (isMobile && mobile) {
    return (
      <Container {...containerProps}>
        <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
          {mobileImageComp}
        </MediaQuery>
      </Container>
    )
  }

  return (
    <Container {...containerProps}>
      <MediaQuery smallerThan="sm" styles={{ display: 'none' }}>
        {desktopRatio === 'auto' ? (
          <img loading="lazy" src={desktop} alt="" />
        ) : (
          <AspectRatio ratio={desktopRatio}>
            <StyledHomeBannerImage url={desktop} />
          </AspectRatio>
        )}
      </MediaQuery>
      <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
        {mobileImageComp}
      </MediaQuery>
    </Container>
  )
}
